export default __webpack_public_path__ + "static/media/In the mountains.82824f68.jpg";